import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
  sliderIndex: number;
  // verifyNINData: HireDispatcherInterface;
}
const initialState: IInitialState = {
  sliderIndex: 0,
  // verifyNINData: HireDispatcherInitialValues,
};

const verifyNINSlice = createSlice({
  name: 'verifyNINSlice',
  initialState,
  reducers: {
    setSliderIndex(state, action: PayloadAction<number>) {
      state.sliderIndex += action.payload;
    },
    resetSliderIndex(state) {
      state.sliderIndex = 0;
    },
    // setVerifyNINData(state, action: PayloadAction<HireDispatcherInterface>) {
    //   state.verifyNINData = action.payload;
    // },
  },
});

export const verifyNINAction = verifyNINSlice.actions;
export default verifyNINSlice.reducer;
